import { format, parseISO, isValid, parse } from 'date-fns';
import { es } from 'date-fns/locale';

type DateInput = Date | string | number | null | undefined;

const toDate = (value: DateInput): Date | null => {
  if (value == null) {
    return null;
  }
  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }
  if (typeof value === 'number') {
    const d = new Date(value);
    return isValid(d) ? d : null;
  }
  const d = parseISO(value as string);
  return isValid(d) ? d : null;
};

export const formatDate = (value: DateInput, fallback = ''): string => {
  const d = toDate(value);
  return d ? format(d, 'dd/MM/yyyy', { locale: es }) : fallback;
};

export const formatDateTime = (value: DateInput, fallback = ''): string => {
  const d = toDate(value);
  return d ? format(d, 'dd/MM/yyyy HH:mm', { locale: es }) : fallback;
};

export const formatDateLong = (value: DateInput, fallback = ''): string => {
  const d = toDate(value);
  return d ? format(d, "d 'de' MMMM 'de' yyyy", { locale: es }) : fallback;
};

export const formatMonthShort = (value: DateInput, fallback = ''): string => {
  const d = toDate(value);
  return d ? format(d, 'MMM yyyy', { locale: es }) : fallback;
};

export const toDateInputValue = (value: DateInput): string => {
  const d = toDate(value);
  return d ? format(d, 'yyyy-MM-dd') : '';
};

export const toDateTimeLocalInputValue = (value: DateInput): string => {
  const d = toDate(value);
  if (!d) {
    return '';
  }
  // Adjust for local timezone so datetime-local input displays local time
  const offset = d.getTimezoneOffset() * 60 * 1000;
  const local = new Date(d.getTime() - offset);
  return local.toISOString().slice(0, 16);
};

export const parseDateInputValue = (s: string): Date | null => {
  if (!s) {
    return null;
  }
  const d = parse(s, 'yyyy-MM-dd', new Date());
  return isValid(d) ? d : null;
};

export const parseDateTimeLocalInputValue = (s: string): Date | null => {
  if (!s) {
    return null;
  }
  const d = new Date(s);
  return isValid(d) ? d : null;
};
